import ServicePageTemplate from '../services/ServicePageTemplate';
import { seoPageData } from '../../mocks/seoPages';
const EmergencyHvacPage = () => <ServicePageTemplate data={seoPageData['emergency-hvac']} />;
export default EmergencyHvacPage;
